import {
  AaaGameConceptDataSet,
  GameConceptsQuery,
  IdXboxGameConceptDataSet,
} from "../../server/crm/api/models/forms";
import { GameConceptsListState } from "../reducers/gameConceptsListReducer";
import { OnboardingRootState } from "../reducers/rootReducer";
import { getOnboardingState } from "./rootSelectors";

const getGameConceptsListState = (state: OnboardingRootState): GameConceptsListState =>
  (getOnboardingState(state) as unknown as Record<string, GameConceptsListState>).gameConcepts;

export const getGameConceptsListData = (
  state: OnboardingRootState
): AaaGameConceptDataSet | IdXboxGameConceptDataSet | undefined =>
  getGameConceptsListState(state)?.gameConceptsList;

export const getGameConceptsListQuery = (
  state: OnboardingRootState
): GameConceptsQuery | undefined => getGameConceptsListState(state)?.gameConceptsListQuery;

export const getGameConceptsListIsLoading = (state: OnboardingRootState): boolean =>
  getGameConceptsListState(state)?.isLoading ?? false;

export const getGameConceptsListError = (state: OnboardingRootState): string | undefined =>
  getGameConceptsListState(state)?.error;

export const getHasGameConceptsList = (state: OnboardingRootState): boolean => {
  const totalCount = getGameConceptsListState(state)?.totalCount;
  return totalCount > 0;
};

export const getGameConceptsTotalCount = (state: OnboardingRootState): number =>
  getGameConceptsListState(state)?.totalCount ?? 0;
